import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css';
import { Box } from "@mui/material";
const modes = ['tree', 'form', 'view', 'code', 'text', 'preview'];
const JsonEditorReact = ({ jsonEditor, ...props }) => {
    useEffect(() => {
        if ('json' in props)
            jsonEditor.update(props.json);
    }, [jsonEditor, props.json]);
    useEffect(() => {
        if (props.text !== undefined)
            jsonEditor.updateText(props.text);
    }, [jsonEditor, props.text]);
    useEffect(() => {
        if (props.options.mode !== undefined)
            jsonEditor.setMode(props.options.mode);
    }, [jsonEditor, props.options.mode]);
    useEffect(() => {
        if (props.options.schema) {
            jsonEditor.setSchema(props.options.schema, props.options.schemaRefs);
        }
    }, [jsonEditor, props.options.schema, props.options.schemaRefs]);
    useEffect(() => () => {
        jsonEditor.destroy();
    }, []);
    return null;
};
// @ts-ignore
const _onValidJson = (props, text) => { if (text === "")
    props.onValidJson(undefined);
else
    try {
        props.onValidJson(JSON.parse(text));
    }
    catch (e) { } };
const handleOnValidJson = (props) => {
    const onChangeText = props.options.onChangeText;
    if (props.onValidJson) {
        props.options.onChangeText = onChangeText ? (text) => {
            onChangeText(text);
            _onValidJson(props, text);
        } : (text) => _onValidJson(props, text);
    }
};
export const JsonEditor = ({ boxProps = {}, ...props }) => {
    const [jsonEditor, setJsonEditor] = useState();
    return (_jsxs(_Fragment, { children: [jsonEditor && _jsx(JsonEditorReact, { jsonEditor: jsonEditor, ...props }, void 0), _jsx(Box, { component: 'div', sx: {
                    width: '100%',
                    height: '100%',
                }, className: "jsoneditor-react-container", ref: element => {
                    if (element) {
                        handleOnValidJson(props);
                        if (!jsonEditor) {
                            setJsonEditor(new JSONEditor(element, props.options));
                        }
                    }
                }, ...boxProps }, void 0)] }, void 0));
};
export const JsonInput = ({ value, onChange = () => null, boxProps }) => {
    const text = useMemo(() => value === undefined ? "" : JSON.stringify(value, null, 2), [value]);
    const [mode, setMode] = useState('code');
    return (_jsx(JsonEditor, { boxProps: boxProps, options: {
            mode,
            modes,
            indentation: 2,
            onModeChange: setMode,
        }, onValidJson: onChange, text: text }, void 0));
};
//# sourceMappingURL=JSONEditorReact.js.map